(function () {
  const readJson = (id) => {
    const el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[GTM] Failed to parse JSON:', id, e);
      return null;
    }
  };

  const pushEcommerceEvent = (eventName, ecommerce) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce
    });
  };

  const pushViewItem = () => {
    const data = readJson('gtm-product-json');
    if (!data) return;
    pushEcommerceEvent('view_item', data);
  };

  const pushViewCart = () => {
    const data = readJson('gtm-cart-json');
    if (!data || !data.items || !data.items.length) return;
    pushEcommerceEvent('view_cart', data);
  };

  const pushBeginCheckout = () => {
    const data = readJson('gtm-cart-json');
    if (!data || !data.items || !data.items.length) return;
    pushEcommerceEvent('begin_checkout', data);
  };

  const pushAddToCart = (lineItem) => {
    if (!lineItem) return;
    const price = Number(lineItem.final_price || lineItem.price || 0) / 100;
    const quantity = Number(lineItem.quantity || 1);
    const currency = (window.ShopifyGtm && window.ShopifyGtm.currency) || 'JPY';

    pushEcommerceEvent('add_to_cart', {
      currency,
      value: price * quantity,
      items: [
        {
          item_id: String(lineItem.variant_id || lineItem.id),
          item_name: lineItem.product_title || lineItem.title || '',
          item_variant: lineItem.variant_title || '',
          price,
          quantity
        }
      ]
    });
  };

  window.ShopifyGtm = window.ShopifyGtm || {};
  window.ShopifyGtm.pushAddToCart = pushAddToCart;

  document.addEventListener('DOMContentLoaded', () => {
    if (window.ShopifyGtm && window.ShopifyGtm.template === 'product') {
      pushViewItem();
    }

    if (window.ShopifyGtm && window.ShopifyGtm.template === 'cart') {
      pushViewCart();

      const checkoutButton = document.getElementById('checkout');
      if (checkoutButton) {
        checkoutButton.addEventListener('click', () => {
          pushBeginCheckout();
        });
      }
    }
  });
})();
